<div class="flex! justify-between!">
  <h4
    mat-dialog-title
    class="text-2xl font-light leading-tight w-full text-center"
  >
    {{ 'AUTH.LOGIN.title' | translate }}
  </h4>
  @if (activeModal) {
    <button
      matIconButton
      type="button"
      class="mt-4 mr-3"
      (click)="activeModal.close()"
      [attr.aria-label]="'Chiudi dialog'"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
</div>
<form
  class="text-center p-8 max-w-2xl mx-auto pt-0!"
  [formGroup]="loginForm"
  (ngSubmit)="onSubmit()"
>
  <p
    class="text-lg md:text-2xl mb-10"
    [ngClass]="{ 'text-error': loginError() }"
  >
    @if (!loginForm.hasError('invalidCredentials')) {
      {{ 'AUTH.LOGIN.subtitle' | translate }}
    } @else {
      {{ loginError() }}
    }
  </p>

  <div class="flex flex-col gap-4">
    @if (!showCredentialsLogin() && showEntraLogin) {
      <lib-entra-login-button
        (buttonClick)="loginWithEntra()"
      ></lib-entra-login-button>
      <p class="entra-login-description text-left text-sm m-0">
        Entra è il metodo di autenticazione messo a disposizione da ASUIT per
        accedere al portale in modo sicuro con il proprio account aziendale.
      </p>

      <p class="text-sm text-on-surface-variant m-0">
        {{ 'AUTH.LOGIN.or' | translate }}
      </p>
      <div class="flex justify-center">
        <button
          mat-button
          color="primary"
          type="button"
          class="w-full"
          (click)="showEmailPasswordLogin()"
        >
          {{ 'AUTH.LOGIN.email_password_toggle' | translate }}
        </button>
      </div>
    } @else {
      <div class="mb-4 text-left">
        <siat-input-field
          [formGroup]="loginForm"
          controlName="codiceFiscale"
          id="codiceFiscale"
          [placeholder]="'ES: AAAAAA11A11A111A'"
          [type]="'text'"
          [label]="'Codice fiscale'"
          autocomplete="username"
        ></siat-input-field>
      </div>
      <div class="mb-4 text-left">
        <siat-input-field
          [formGroup]="loginForm"
          controlName="password"
          id="password"
          [placeholder]="'Inserisci la tua password'"
          [type]="'text'"
          [label]="'Password'"
          [arePasswordField]="true"
        ></siat-input-field>
      </div>
      @if (requiresActivationCode && activationCodeGenerated()) {
        <p class="activation-code-message text-left text-sm mb-4">
          Hai a disposizione 2 minuti per inserire il codice di attivazione.
          Dopo questo periodo, la sessione scadrà e sarà necessario ripetere la
          procedura.
        </p>
        <div class="mb-4 text-left">
          <siat-input-field
            [formGroup]="loginForm"
            controlName="pin"
            id="pin"
            [placeholder]="'Inserisci il codice di attivazione'"
            [type]="'text'"
            [label]="'Codice di attivazione'"
          ></siat-input-field>
        </div>
      }
      <div class="flex justify-end">
        @if (requiresActivationCode && !activationCodeGenerated()) {
          <button
            matButton="filled"
            [disabled]="credentialsInvalid || isGeneratingActivationCode()"
            type="submit"
            class="px-4 py-2"
            [matTooltip]="'Genera codice attivazione'"
          >
            Genera codice attivazione
          </button>
        } @else {
          <button
            matButton="filled"
            [disabled]="loginForm.invalid || isLoggingIn()"
            type="submit"
            class="px-4 py-2 min-w-32! flex! items-center! justify-center! gap-2!"
            [matTooltip]="'AUTH.LOGIN.submit' | translate"
          >
            @if (isLoggingIn()) {
              <mat-progress-spinner
                diameter="18"
                mode="indeterminate"
                class="inline-block! align-middle!"
                aria-label="Accesso in corso"
              ></mat-progress-spinner>
            }
            {{ 'AUTH.LOGIN.submit' | translate }}
          </button>
        }
      </div>

      @if (showEntraLogin) {
        <p class="text-sm text-on-surface-variant m-0">
          {{ 'AUTH.LOGIN.or' | translate }}
        </p>

        <lib-entra-login-button
          (buttonClick)="loginWithEntra()"
        ></lib-entra-login-button>
      }
    }
  </div>
</form>
